import {
    Badge,
    Bleed,
    BlockStack,
    Box,
    Button,
    Card,
    Divider,
    InlineGrid,
    InlineStack,
    Popover,
    Spinner,
    Text,
    Thumbnail,
} from '@shopify/polaris';
import React, { useState } from 'react';
import CloseMatch from '../CloseMatch';
import Unlinked from '../Unlinked';
import Linked from '../Linked';
import Deleted from '../Deleted';
import Noimage from "../../../../../../public/files/noImage.png";
import { useTranslation } from 'react-i18next';

export const europeRegion = [
    {
        label: "United Arab Emirates (U.A.E.)",
        seller_profile_url: "https://www.amazon.ae/sp",
        value: "AE",
        marketplace_id: "A2VIGQ35RCS4UG",
        region: "EU",
        currency: "AED",
        url: "Amazon.ae",
        failed_order_url: "https://sellercentral.amazon.ae",
    },
    {
        label: "Belgium",
        seller_profile_url: "https://www.amazon.com.be/sp",
        value: "BE",
        marketplace_id: "AMEN7PMS3EDWL",
        region: "EU",
        currency: "Euro",
        url: "Amazon.com.be",
        currency_symbol: 'Euro '
    },
    {
        label: "Germany",
        seller_profile_url: "https://www.amazon.de/sp",
        value: "DE",
        marketplace_id: "A1PA6795UKMFR9",
        region: "EU",
        currency: "EUR",
        url: "Amazon.de",
        failed_order_url: "https://sellercentral-europe.amazon.com",
    },
    {
        label: "Spain",
        seller_profile_url: "https://www.amazon.es/sp",
        value: "ES",
        marketplace_id: "A1RKKUPIHCS9HS",
        region: "EU",
        currency: "EUR",
        url: "Amazon.es",
        failed_order_url: "https://sellercentral-europe.amazon.com",
    },
    {
        label: "Saudi Arabia",
        seller_profile_url: "https://www.amazon.sa/sp",
        value: "SA",
        marketplace_id: "A17E79C6D8DWNP",
        region: "EU",
        currency: "Saudi Riyal",
        url: "Amazon.sa",
        currency_symbol: 'Saudi Riyal '
    },
    {
        label: "Egypt",
        seller_profile_url: "https://www.amazon.eg/sp",
        value: "EG",
        marketplace_id: "ARBP9OOSHTCHU",
        region: "EU",
        currency: "Egyptian Pound",
        url: "Amazon.eg",
        currency_symbol: 'E£'
    },
    {
        label: "Turkey",
        seller_profile_url: "https://www.amazon.com.tr/sp",
        value: "TR",
        marketplace_id: "A33AVAJ2PDY3EV",
        region: "EU",
        currency: "Turkish Lira",
        url: "Amazon.com.tr",
        currency_symbol: '₺'
    },
    {
        label: "France",
        seller_profile_url: "https://www.amazon.fr/sp",
        value: "FR",
        marketplace_id: "A13V1IB3VIYZZH",
        region: "EU",
        currency: "EUR",
        url: "Amazon.fr",
        failed_order_url: "https://sellercentral-europe.amazon.com",
    },
    {
        label: "UK",
        seller_profile_url: "https://www.amazon.co.uk/sp",
        value: "GB",
        marketplace_id: "A1F83G8C2ARO7P",
        region: "EU",
        currency: "GBP",
        url: "Amazon.co.uk",
        failed_order_url: "https://sellercentral-europe.amazon.com",
    },
    {
        label: "India",
        seller_profile_url: "https://amazon.in/sp",
        value: "IN",
        marketplace_id: "A21TJRUUN4KGV",
        region: "IN",
        currency: "INR",
        url: "Amazon.in",
        failed_order_url: "https://sellercentral.amazon.in",
    },
    {
        label: "Italy",
        seller_profile_url: "https://www.amazon.it/sp",
        value: "IT",
        marketplace_id: "APJ6JRA9NG5V4",
        region: "EU",
        currency: "EUR",
        url: "Amazon.it",
        failed_order_url: "https://sellercentral-europe.amazon.com",
    },
    {
        label: "Netherlands",
        seller_profile_url: "https://www.amazon.nl/sp",
        value: "NL",
        marketplace_id: "A1805IZSGTT6HS",
        region: "EU",
        currency: "EUR",
        url: "Amazon.nl",
        failed_order_url: "https://sellercentral.amazon.nl",
    },
    {
        label: "Poland",
        seller_profile_url: "https://www.amazon.pl/sp",
        value: "PO",
        marketplace_id: "A1C3SOZRARQ6R3",
        region: "EU",
        currency: "PLN",
        url: "Amazon.pl",
        failed_order_url: "https://sellercentral.amazon.pl",
    },
    {
        label: "South Africa",
        seller_profile_url: "https://www.amazon.co.za/sp",
        value: "ZA",
        marketplace_id: "AE08WJ6YKNBMC",
        region: "EU",
        currency: "ZAR",
        url: "Amazon.co.za",
        currency_symbol: 'ZAR '
    },
    {
        label: "Sweden",
        seller_profile_url: "https://www.amazon.se/sp",
        value: "SE",
        marketplace_id: "A2NODRKZP88ZB9",
        region: "EU",
        currency: "SEK",
        url: "Amazon.se",
        failed_order_url: "https://sellercentral.amazon.se",
    },
    {
        label: "Ireland",
        seller_profile_url: "https://www.amazon.ie",
        value: "IE",
        marketplace_id: "A28R8C7NBKEWEA",
        region: "EU",
        currency: "Euro",
        url: "Amazon.ie",
        failed_order_url: "https://sellercentral.amazon.ie",
    },
];

export const fareastRegion = [
    {
        label: "Singapore",
        seller_profile_url: "https://www.amazon.sg/sp",
        value: "SG",
        marketplace_id: "A19VAU5U5O7RUS",
        region: "FE",
        currency: "SGD",
        url: "Amazon.com.sg",
        failed_order_url: "https://sellercentral.amazon.sg",
    },
    {
        label: "Australia",
        seller_profile_url: "https://www.amazon.com.au/sp",
        value: "AU",
        marketplace_id: "A39IBJ37TRP1C6",
        region: "FE",
        currency: "AUD",
        url: "Amazon.com.au",
        failed_order_url: "https://sellercentral.amazon.com.au",
    },
    {
        label: "Japan",
        seller_profile_url: "https://www.amazon.co.jp/sp",
        value: "JP",
        marketplace_id: "A1VC38T7YXB528",
        region: "FE",
        currency: "JPY",
        url: "Amazon.co.jp",
        failed_order_url: "https://sellercentral.amazon.co.jp",
    },
];

export const northAmericaRegion = [
    {
        label: "Brazil",
        seller_profile_url: "https://www.amazon.com.br/sp",
        value: "BR",
        marketplace_id: "A2Q3Y263D00KWC",
        region: "NA",
        currency: "BRL",
        url: "Amazon.com.br",
        failed_order_url: "https://sellercentral.amazon.com.br",
    },
    {
        label: "Canada",
        seller_profile_url: "https://www.amazon.ca/sp",
        value: "CA",
        marketplace_id: "A2EUQ1WTGCTBG2",
        region: "NA",
        currency: "CAD",
        url: "Amazon.ca",
        failed_order_url: "https://sellercentral.amazon.ca",
    },
    {
        label: "Mexico",
        seller_profile_url: "https://www.amazon.com.mx/sp",
        value: "MX",
        marketplace_id: "A1AM78C64UM0Y8",
        region: "NA",
        currency: "MXN",
        url: "Amazon.com.mx",
        failed_order_url: "https://sellercentral.amazon.com.mx",
    },
    {
        label: "US",
        seller_profile_url: "https://www.amazon.com/sp",
        value: "US",
        marketplace_id: "ATVPDKIKX0DER",
        region: "NA",
        currency: "USD",
        url: "Amazon.com",
        failed_order_url: "https://sellercentral.amazon.com",
    },
];

export function getAmazonRegion(value: string, findField = "value") {
    let regionCollection = [
        ...europeRegion,
        ...fareastRegion,
        ...northAmericaRegion,
    ];
    let regionInfo = regionCollection.filter(
        (countryObj: any) => countryObj[findField] === value
    );
    if (regionInfo.length) return regionInfo[0];
    return false;
}

// export function getNecsessaryDetails(props:any) {

// }

// export const myTabs = (loader: boolean, listingCount: any, viewTab: number, viewSku: string) => {
//     return (
//         [
//             {
//                 id: 'close-match',
//                 content: (
//                     <InlineStack gap='100'>
//                         <Text as='span'>Close Match</Text>
//                         {loader ? <Spinner size='small' /> : <Badge tone="success">{listingCount?.close_matched?.toString() ?? '0'}</Badge>}
//                     </InlineStack>
//                 ),
//                 accessibilityLabel: 'Close Match',
//                 panelID: 'close-match',
//                 TabContent: (
//                     <CloseMatch
//                         viewSku={viewTab === 0 ? viewSku : ""}
//                     />
//                 ),
//             },
//             {
//                 id: 'linking-required',
//                 content: (
//                     <InlineStack gap='100'>
//                         <Text as='span'>Linking Required</Text>
//                         {loader ? <Spinner size='small' /> : <Badge tone="warning">{listingCount?.not_linked?.toString() ?? 0}</Badge>}
//                     </InlineStack>
//                 ),
//                 panelID: 'linking-required',
//                 TabContent: (
//                     <div>
//                         <Unlinked
//                             viewSku={viewTab === 1 ? viewSku : ""}
//                         />
//                     </div>
//                 ),
//             },
//             {
//                 id: 'linked',
//                 content: (
//                     <InlineStack gap='100'>
//                         <Text as='span'>Linked</Text>
//                         {loader ? <Spinner size='small' /> : <Badge tone="new">{listingCount?.linked?.toString() ?? 0}</Badge>}
//                     </InlineStack>
//                 ),
//                 panelID: 'linked',
//                 TabContent: (
//                     <Linked
//                         viewSku={viewTab === 2 ? viewSku : ""}
//                     />
//                 ),
//             },
//             {
//                 id: 'deleted',
//                 content: (
//                     <InlineStack gap="100">
//                         <Text as="span">Deleted Listings</Text>
//                         {loader ? (
//                             <Spinner size="small" />
//                         ) : (
//                             <Badge tone="attention">
//                                 {listingCount?.deleted?.toString() ?? 0}
//                             </Badge>
//                         )}
//                     </InlineStack>
//                 ),
//                 panelID: 'deleted',
//                 TabContent: (
//                     <div>
//                         <Deleted
//                             viewSku={viewTab === 1 ? viewSku : ''}
//                         />
//                     </div>
//                 ),
//             }
//         ]
//     )
// }

interface ListingCount {
    close_matched?: number;
    not_linked?: number;
    linked?: number;
    deleted?: number;
}

interface MyTabsItem {
    id: string;
    content: JSX.Element;
    accessibilityLabel?: string;
    panelID: string;
    TabContent: JSX.Element;
}

type MyTabsFunction = (loader: boolean, listingCount: ListingCount, viewTab: number, viewSku: string) => any[];//To be checked later for MyTabsItem

export const myTabs: MyTabsFunction = (loader, listingCount, viewTab, viewSku) => {
    const { t } = useTranslation();
    return [
        {
            id: 'close-match',
            content: (
                <InlineStack gap='100' wrap={false}>
                    <Text as='span'>{t("Close Match")}</Text>
                    {loader ? <Spinner size='small' /> : <Badge tone="warning">{listingCount?.close_matched?.toString() ?? '0'}</Badge>}
                </InlineStack>
            ),
            accessibilityLabel: 'Close Match',
            panelID: 'close-match',
            TabContent: (<CloseMatch viewSku={viewTab === 0 ? viewSku : ""} />),
        },
        {
            id: 'linking-required',
            content: (
                <InlineStack gap='100' wrap={false}>
                    <Text as='span'>{t("Linking Required")}</Text>
                    {loader ? <Spinner size='small' /> : <Badge tone="info">{listingCount?.not_linked?.toString() ?? '0'}</Badge>}
                </InlineStack>
            ),
            panelID: 'linking-required',
            TabContent: (<div><Unlinked viewSku={viewTab === 1 ? viewSku : ""} /></div>),
        },
        {
            id: 'linked',
            content: (
                <InlineStack gap='100' wrap={false}>
                    <Text as='span'>{t("Linked")}</Text>
                    {loader ? <Spinner size='small' /> : <Badge tone="success">{listingCount?.linked?.toString() ?? '0'}</Badge>}
                </InlineStack>
            ),
            panelID: 'linked',
            TabContent: (<Linked viewSku={viewTab === 2 ? viewSku : ""} />),
        },
        {
            id: 'deleted',
            content: (
                <InlineStack gap="100" wrap={false}>
                    <Text as="span">{t("Listings not found")}</Text>
                    {loader ? <Spinner size="small" /> : <Badge tone="critical">{listingCount?.deleted?.toString() ?? '0'}</Badge>}
                </InlineStack>
            ),
            panelID: 'deleted',
            TabContent: (<div><Deleted viewSku={viewTab === 1 ? viewSku : ''} /></div>),
        }
    ];
};


export const ViewMoreInfo = ({ val, renderStatusOfProduct, current_shop_currency }: any) => {
    const { t } = useTranslation()
    const [viewMoreInfo, setViewMoreInfo] = useState('')
    return <Popover
        activator={<div>
            <Button variant='plain' onClick={() => {
                setViewMoreInfo(id => id === val?._id?.$oid ? '' : val?._id?.$oid)
            }}>{t("View more info")}</Button>
        </div>}
        active={viewMoreInfo === val?._id?.$oid}
        onClose={() => {
            setViewMoreInfo('');
        }}
        preferredAlignment='left'
        preferredPosition='below'
    >
        <Card>
            <BlockStack gap='400'>
                <InlineStack gap='300' wrap={false} align='start'>
                    <div><Thumbnail source={val?.['image-url'] && val?.['image-url'] != "" ? val?.['image-url'] : Noimage} alt='' /></div>
                    <Text as='h3' variant='headingSm'>{val['item-name']}</Text>
                </InlineStack>
                <Card>
                    <Box paddingBlockEnd='400'>
                        <InlineGrid gap='400' columns={2} >
                            <Text as='p' tone='subdued'>{t("Status")}</Text>
                            <Text as='p'>{renderStatusOfProduct(val?.['status'])}</Text>
                        </InlineGrid>
                    </Box>
                    <Bleed marginInline='400'><Divider /></Bleed>
                    <Box paddingBlock='400'>
                        <InlineGrid gap='400' columns={2} >
                            <Text as='p' tone='subdued'>{t("Inventory")}</Text>
                            <Text as='p'>{val?.quantity}</Text>
                        </InlineGrid>
                    </Box>
                    <Bleed marginInline='400'><Divider /></Bleed>
                    <Box paddingBlock='400'>
                        <InlineGrid gap='400' columns={2} >
                            <Text as='p' tone='subdued'>{t("Price")}</Text>
                            <Text as='p'>{`${current_shop_currency?.['currency_symbol']}${val?.price}`}</Text>
                        </InlineGrid>
                    </Box>
                    <Bleed marginInline='400'><Divider /></Bleed>
                    <Box paddingBlock='400'>
                        <InlineGrid gap='400' columns={2} >
                            <Text as='p' tone='subdued'>{t("SKU")}</Text>
                            <Text as='p' breakWord={true}>{val?.['seller-sku']}</Text>
                        </InlineGrid>
                    </Box>
                    <Bleed marginInline='400'><Divider /></Bleed>
                    <Box paddingBlockStart='400'>
                        <InlineGrid gap='400' columns={2} >
                            <Text as='p' tone='subdued'>{t("Barcode")}</Text>
                            <Text as='p' breakWord={true}>{val?.['product-id']}</Text>
                        </InlineGrid>
                    </Box>
                </Card>
            </BlockStack>
        </Card>
    </Popover>
}
